module.exports = __webpack_public_path__ + "img/benjike3.981ec9e1.png";